export default "__VITE_ASSET__DKQfLooH__"